import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { ContentHashMap } from '../../../core/util/ContentHashMap';
export const Image = (props) => {
    const { hashImage = true } = props;
    const srcString = React.useMemo(() => {
        if (props.src === undefined) {
            return undefined;
        }
        if (!hashImage) {
            return props.src;
        }
        return ContentHashMap.getContentHashPath(props.src);
    }, [hashImage, props.src]);
    return (_jsx("img", Object.assign({}, props, { src: srcString })));
};
//# sourceMappingURL=Image.js.map